module.exports = __webpack_public_path__ + "assets/img/TMSP2-1.cc2eae1f.png";